export default function BurgerHackIcon() {
  return (
    <div className="avatar">
      <div className="w-[55px] h-[60px] rounded">
        <img src="/burger-hack.png" alt="logo" />
      </div>
    </div>
  )
}
